import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import ColorWheel from "./ColorWheel";

export default function Filters({ selectedCategory, onFiltersChange }) {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({});

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://bbjlatavola.com/wp-json/products/v1.0/filters?product_cat=${selectedCategory}`
      );

      constructStateFromFilters(response.data.filters);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    setFilters({});
    onFiltersChange({});
    setSearch("");
  }, [selectedCategory]);

  const constructStateFromFilters = (filters) => {
    const newState = {};
    Object.keys(filters).forEach((key) => {
      let filtersArray = filters[key].filters;
      if (filtersArray && filtersArray.length > 0) {
        filtersArray = ["All", ...filtersArray];
        newState[key === "color" ? "colors" : key] = filtersArray;
      }
    });
    setData(newState);
  };

  const handleFilters = (key, value) => {
    try {
      if (key === "color") {
        key = "colors";
      }
      const currentStateFilters = { ...filters };
      const index = currentStateFilters[key].indexOf(value);

      if (currentStateFilters[key].includes("All") && value === "All") {
        currentStateFilters[key] = [];
      } else if (value === "All") {
        currentStateFilters[key] = [...data[key]];
      } else {
        if (index === -1) {
          currentStateFilters[key] = [...currentStateFilters[key], value];
        } else {
          currentStateFilters[key] = currentStateFilters[key].filter(
            (item) => item !== value && item !== "All"
          );
        }
      }
      if (search) {
        currentStateFilters["searching"] = search;
      }

      setFilters(currentStateFilters);
      onFiltersChange(currentStateFilters);
    } catch (err) {
      console.log("err: ", err);
    }
  };

  useEffect(() => {
    if (typeof data === "object" && data !== null) {
      let objects = {};
      Object.keys(data).forEach((key) => {
        if (key === "color") {
          key = "colors";
        }
        objects[key] = [];
      });

      setFilters(objects);
    }
  }, [data]);

  // Inside the component (above return)
  const applySearchFilter = () => {
    const currentStateFilters = { ...filters };
    currentStateFilters["searching"] = search;
    setFilters(currentStateFilters);
    onFiltersChange(currentStateFilters);
  };

  return (
    <>
      <Grid mt={2}>
        <Grid item>
          <Typography className="filter-head" mb={2} variant="h5">
            Search
          </Typography>
          <TextField
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                applySearchFilter();
              }
            }}
            id="search"
            label="Search"
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={applySearchFilter}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item mt={2}>
          <Box
            sx={{
              display: "none",
              background: "#e7e7e7",
              position: "relative",
              height: "170px",
            }}
          >
            <ColorWheel onChange={(key, value) => handleFilters(key, value)} />
          </Box>
          {Object.keys(data).length > 0 && (
            <>
              {Object.keys(data).map((key, index) => (
                <>
                  <Accordion key={index}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3-content"
                      id="panel3-header"
                    >
                      <Typography className="filter-head"> {key}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {data[key].map((f, index) => (
                        <Box
                          key={f + index}
                          alignItems="center"
                          justifyContent="space-between"
                          display="flex"
                          flexDirection="row"
                          width="100%"
                        >
                          <Typography className="filter-label" key={f}>
                            {f}
                          </Typography>
                          <FormControlLabel
                            control={
                              <input
                                type="checkbox"
                                checked={filters[key]?.includes(f)}
                                onChange={() => handleFilters(key, f)}
                              />
                            }
                          />
                        </Box>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                </>
              ))}
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
}
